import ADIColors from "@NA/Utils/ADIColors";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

const enum fields {
    heading = "heading",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
    };
}

type Props = OwnProps;

export interface SideFilterStyles {
    heading?: TypographyProps;
    accordianStyle?: AccordionPresentationProps;
    accordianWrapper?: AccordionSectionPresentationProps;
}

export const styles: SideFilterStyles = {
    heading: {
        variant: "h3",
        css: css`
            border-top: none !important;
            width: 206px;
            height: 30px;
            border-radius: 7px;
            background-color: ${getColor("common.background")};
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            line-height: 1.5;
            padding: 5px 10px 3px;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
            color: ${getColor("text.main")};
            font-weight: 800;
        `,
    },

    accordianStyle: {
        css: css`
            margin-top: 5px;
            background-color: ${getColor("common.background")};
        `,
    },
    accordianWrapper: {
        headerProps: {
            css: css`
                button {
                    border-top: none !important;
                    height: 30px;
                    border-radius: 7px;
                    background-color: ${getColor("common.background")};
                    font-size: 14px;
                    font-weight: 800;
                    line-height: 1.5;
                    padding: 5px 10px 3px;
                    border-bottom-right-radius: 0;
                    border-bottom-left-radius: 0;
                    border: none;
                    :focus {
                        border-color: none;
                        border-style: none;
                        border-width: 0;
                        outline: 0;
                    }
                    span[class^="IconWrapper"] {
                        margin-right: -5px;
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                height: 291px;
                background-color: ${ADIColors.gray1};
                padding: 5px 10px 6px;
                overflow: hidden;
                overflow-x: hidden;
                border-bottom: 3px solid ${ADIColors.listBorderGray} !important;
                border-bottom-left-radius: 7px;
                border-bottom-right-radius: 7px;
                border: none;
                div[class^="GridOffset"] {
                    height: 283px;
                    overflow-y: scroll;
                    overflow-x: hidden;
                    ::-webkit-scrollbar {
                        width: 9px;
                    }
                    ::-webkit-scrollbar-track {
                        background-color: ${getColor("common.background")};
                        border-radius: 10px;
                    }

                    ::-webkit-scrollbar-thumb {
                        background-color: rgb(124, 147, 173);
                        border-radius: 10px;
                    }
                }

                a[class^="StyledButton"] {
                    span[class^="TypographyStyle"] {
                        font-size: ${getProp("theme.typography.headerSecondary.size")};
                        color: ${getColor("text.main")};

                        :hover {
                            color: ${getColor("primary")};
                            text-decoration: underline !important;
                        }
                    }
                }
            `,
        },
    },
};

export const ADIListAccordion: React.FC<Props> = ({ id, fields }) => {
    return (
        <Accordion headingLevel={1} {...styles.accordianStyle}>
            <AccordionSection title={fields.heading} {...styles.accordianWrapper} expanded>
                <Zone contentId={id} zoneName="content" />
            </AccordionSection>
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: ADIListAccordion,
    definition: {
        group: "Basic",
        displayName: "ADI List Accordion",
        fieldDefinitions: [
            {
                name: fields.heading,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Categories",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
